import { ref, computed } from 'vue'
import { useScreens } from '@/Composables/screens'

const scrollLock = ref(false)
const { isNarrowScreen } = useScreens()
const shouldLock = computed(() => scrollLock.value && !isNarrowScreen.value)

export const useLayoutState = () => {
  return {
    shouldLock,
    setScrollLock: (lock = true) => {
      scrollLock.value = lock
    }
  }
}
